import { cartEventEmitter as N, useCartState as ie } from "@made-people/grease-cart";
import { getProductAttribute as C, productEventEmitter as k, useMaybeProductBase as se } from "@made-people/grease-product";
import { orderEventEmitter as V } from "@made-people/grease-order";
import { useEffectOnce as ae, once as ne } from "@made-people/react-use-effect-once";
import { createContext as B, useContext as M, useState as ce, useMemo as S, useCallback as le, useEffect as ue } from "react";
import I, { z as o } from "zod";
import { jsx as A, Fragment as de, jsxs as ge } from "react/jsx-runtime";
import { useGlobalSearchSettings as me, emptySearchResult as y, searchResultQueryMethodsContext as fe, SearchResultProvider as he, useFacetGrouping as pe, useCurrentPaginationPage as ye, CachedSearchResultsProvider as be, AutoCompleteProvider as Pe } from "@made-people/grease-search";
import { withManagedProps as K } from "@made-people/managed-props";
import { withZod as Q } from "@made-people/react-prop-guard";
import { crc32 as Ae } from "@made-people/functions-crc32";
const W = B(void 0), z = B(
  void 0
), R = () => {
  const e = M(W);
  if (!e)
    throw new Error(
      "useAlgoliaSearchClient must be used within an AlgoliaProvider"
    );
  return e;
}, v = () => {
  const e = M(z);
  if (!e)
    throw new Error("useAlgoliaConfig must be used within an AlgoliaProvider");
  return e;
}, D = "algolia_object_id", _ = (e) => {
  var r;
  return (r = C(
    e.attributes,
    D,
    I.string()
  )) == null ? void 0 : r.value;
}, Se = () => {
  const e = R(), r = v();
  return async (i, t, s, a) => {
    var n, c, l, d;
    try {
      const f = await e();
      if (!f) {
        console.warn("Algolia client not configured, skipping insights event");
        return;
      }
      const { indexName: g, insightsClient: h } = f, u = (n = C(
        s.attributes,
        D,
        I.string()
      )) == null ? void 0 : n.value;
      if (!u) {
        console.warn(
          "Algolia objectID not found in product attributes, skipping insights event"
        );
        return;
      }
      if (!g) {
        console.warn("Algolia index name not found, skipping insights event");
        return;
      }
      const p = (c = C(
        s.attributes,
        "algolia_query_id",
        I.string()
      )) == null ? void 0 : c.value, b = (l = C(
        s.attributes,
        "algolia_position",
        I.number()
      )) == null ? void 0 : l.value, m = {
        eventType: i,
        eventName: t,
        index: g,
        objectIDs: [u],
        userToken: ((d = r.insights) == null ? void 0 : d.userToken) ?? "",
        // Add eventSubtype for conversion events
        ...a && { eventSubtype: a },
        // Add queryID for search events
        ...p && { queryID: p },
        // Add positions array for click events when position is available
        ...i === "click" && b !== void 0 && { positions: [b] }
      };
      await h.pushEvents({
        events: [m]
      });
    } catch (f) {
      console.error(
        `Error sending ${i} insights event to Algolia`,
        f
      );
    }
  };
}, ve = () => {
  const e = Se(), r = async (t) => {
    t.context.type === "pdp" ? await e("view", "PDP Viewed", t.productData.base) : t.context.type === "plp" && await e("view", "PLP Viewed", t.productData.base);
  }, i = async (t) => {
    var s;
    if ((s = t.order) != null && s.items)
      for (const a of t.order.items)
        a.type === "product" && await e(
          "conversion",
          "Product Purchased",
          a.product.base,
          "purchase"
        );
  };
  return ae(() => (k.on("productClicked", async (t) => {
    await e("click", "Product Clicked", t.productData.base);
  }), k.on("productViewed", async (t) => {
    await r(t);
  }), N.on("addToCart", async (t) => {
    await e(
      "conversion",
      "Product Added to Cart",
      t.payload.product,
      "addToCart"
    );
  }), V.on("orderPlaced", async (t) => {
    await i(t);
  }), () => {
    k.off("productClicked", async (t) => {
      await e(
        "click",
        "Product Clicked",
        t.productData.base
      );
    }), k.off("productViewed", async (t) => {
      await r(t);
    }), N.off("addToCart", async (t) => {
      await e(
        "conversion",
        "Product Added to Cart",
        t.payload.product,
        "addToCart"
      );
    }), V.off("orderPlaced", async (t) => {
      await i(t);
    });
  })), null;
}, we = o.object({
  periodDays: o.number(),
  price: o.string(),
  priceAsNumber: o.number(),
  priceBeforeDiscount: o.string(),
  priceBeforeDiscountAsNumber: o.number()
}), q = o.union([
  o.number(),
  o.literal("infinite")
]), Ct = o.array(o.never()).length(0), ke = o.object({
  category: o.number(),
  primary: o.boolean(),
  sortOrder: o.number(),
  name: o.string(),
  uri: o.string(),
  uriForProduct: o.string()
}), Ce = o.object({
  price: o.string(),
  priceBeforeDiscount: o.string(),
  priceReduction: o.string(),
  priceAsNumber: o.number(),
  priceBeforeDiscountAsNumber: o.number(),
  priceReductionAsNumber: o.number(),
  discountPercent: o.number(),
  showAsOnSale: o.boolean(),
  newProduct: o.boolean(),
  lowestPrice: o.array(we).optional()
}), Ie = o.object({
  stockOfAllItems: q,
  pricesByPricelist: o.record(Ce).optional()
}), U = o.object({
  minimum: o.number(),
  maximum: o.number()
}), De = o.object({
  product: o.string(),
  measureQuantity: o.number(),
  quantity: U
}), Ee = o.object({
  priceCalculation: o.string().optional(),
  measureQuantity: U,
  products: o.array(De)
}).passthrough(), Fe = o.object({
  type: o.string(),
  priceType: o.string(),
  priceOfItems: o.record(o.number()),
  discount: o.record(o.number())
}), Oe = o.object({
  item: o.string(),
  name: o.string(),
  ean: o.string(),
  sku: o.string(),
  stockByMarket: o.record(q),
  stockByWarehouse: o.record(q).optional()
}).passthrough(), je = o.object({
  product: o.string(),
  name: o.string(),
  uri: o.string(),
  preview: o.boolean().optional(),
  sku: o.string(),
  productSku: o.string(),
  brand: o.string(),
  brandName: o.string(),
  collection: o.string().nullable(),
  collectionName: o.string().nullable(),
  silkProduct: o.string(),
  silkProductName: o.string(),
  silkVariant: o.string(),
  silkVariantName: o.string(),
  folderName: o.string().nullable(),
  foldersName: o.string(),
  variantName: o.string(),
  primaryVariant: o.boolean(),
  excerpt: o.string(),
  description: o.string(),
  metaTitle: o.string(),
  metaDescription: o.string(),
  metaKeywords: o.string(),
  weight: o.number(),
  weightUnit: o.string(),
  stockUnit: o.string(),
  supplierName: o.string().nullish(),
  createdAt: o.string(),
  measurementCart: o.string().nullish(),
  measurementChartRows: o.record(o.any()),
  harmCode: o.string(),
  harmCodeDescription: o.string(),
  countryOfOrigin: o.string(),
  countryOfOriginName: o.string(),
  color_swatch: o.object({
    description: o.string(),
    image: o.object({
      type: o.string(),
      url: o.string(),
      width: o.string(),
      height: o.string(),
      mimeType: o.string()
    }).optional()
  }).optional(),
  markets: o.record(Ie),
  items: o.union([
    o.record(Oe),
    o.array(o.never()).length(0)
  ]),
  canonicalCategory: o.number(),
  canonicalUri: o.string(),
  categories: o.array(ke),
  media: o.array(
    o.object({
      type: o.string(),
      sources: o.record(
        o.object({
          url: o.string(),
          width: o.number(),
          height: o.number(),
          mimeType: o.string()
        })
      )
    })
  ),
  localized: o.record(o.any()).optional(),
  variant_canonical: o.string().optional(),
  relatedProducts: o.array(
    o.object({
      product: o.string(),
      relation: o.string()
    })
  ).optional(),
  bundle: Ee.optional(),
  bundleInfo: Fe.optional()
}).passthrough(), H = o.object({
  objectID: o.string(),
  algoliaTypeID: o.literal("product"),
  gearsLoaderType: o.literal("centra-shop-api-product-loader")
}), qe = je.merge(H).passthrough(), T = (e) => H.safeParse(e).success, Re = [
  "related-products",
  "bought-together",
  "looking-similar"
], Te = () => {
  const e = v(), r = R(), i = me();
  return async (t) => {
    var d, f, g, h;
    const s = t.maxRecommendations ?? i.defaultItemsPerPage, a = await r();
    if (!a)
      return console.error("Algolia: Client data not available"), y;
    const { indexName: n, recommendClient: c } = a, l = t.objectID;
    if (!l && Re.includes(t.model))
      return console.error(
        `Algolia: objectID is required for recommendation model: ${t.model}`
      ), y;
    try {
      let u;
      switch (t.model) {
        case "related-products":
          if (!l)
            return y;
          u = await c.getRecommendations({
            requests: [
              {
                model: "related-products",
                indexName: n,
                objectID: l,
                threshold: 0,
                maxRecommendations: s,
                queryParameters: t.queryParameters,
                fallbackParameters: t.fallbackParameters
              }
            ]
          });
          break;
        case "bought-together":
          if (!l)
            return y;
          u = await c.getRecommendations({
            requests: [
              {
                model: "bought-together",
                indexName: n,
                objectID: l,
                threshold: 0,
                maxRecommendations: s,
                queryParameters: t.queryParameters
              }
            ]
          });
          break;
        case "trending-items":
          u = await c.getRecommendations({
            requests: [
              {
                model: "trending-items",
                indexName: n,
                threshold: 0,
                maxRecommendations: s,
                queryParameters: t.queryParameters,
                fallbackParameters: t.fallbackParameters
              }
            ]
          });
          break;
        case "trending-facets":
          u = await c.getRecommendations({
            requests: [
              {
                model: "trending-facets",
                indexName: n,
                facetName: ((f = (d = t.queryParameters) == null ? void 0 : d.facetFilters) == null ? void 0 : f[0]) || "",
                threshold: 0,
                maxRecommendations: s
              }
            ]
          });
          break;
        case "looking-similar":
          if (!l)
            return y;
          u = await c.getRecommendations({
            requests: [
              {
                model: "looking-similar",
                indexName: n,
                objectID: l,
                threshold: 0,
                maxRecommendations: s,
                queryParameters: t.queryParameters,
                fallbackParameters: t.fallbackParameters
              }
            ]
          });
          break;
        default:
          return console.error(
            `Algolia: Unknown recommendation model: ${t.model}`
          ), y;
      }
      if (!((h = (g = u == null ? void 0 : u.results) == null ? void 0 : g[0]) != null && h.hits))
        return y;
      const b = u.results[0].hits.map((m) => {
        if (T(m)) {
          const P = e.mappers.centraShopProduct(m);
          return P ? {
            type: "product",
            product: P
          } : void 0;
        }
      }).filter((m) => m !== void 0);
      return {
        items: b,
        meta: {
          totalItems: b.length,
          itemsPerPage: b.length,
          currentPage: 1,
          totalPages: 1
        },
        facets: [],
        // Not supported for recommendations by Algolia
        sort: []
        // Not supported for recommendations by Algolia
      };
    } catch (u) {
      return console.error("Algolia: Error fetching recommendations", u), y;
    }
  };
}, $e = o.object({
  model: o.enum([
    "related-products",
    "bought-together",
    "trending-items",
    "trending-facets",
    "looking-similar"
  ]),
  objectID: o.string().optional(),
  maxRecommendations: o.number().optional(),
  queryParameters: o.object({
    filters: o.string().optional(),
    facetFilters: o.array(o.string()).optional(),
    numericFilters: o.array(o.string()).optional()
  }).optional(),
  fallbackParameters: o.object({
    filters: o.string().optional(),
    facetFilters: o.array(o.string()).optional()
  }).optional(),
  children: o.any()
}), xe = K(
  "AlgoliaRecommendations",
  Q(
    $e,
    (e) => {
      const { cart: r } = ie(), i = se(), [t, s] = ce(
        void 0
      ), a = S(() => {
        var h;
        if (e.objectID)
          return e.objectID;
        if (i) {
          const u = _(i);
          if (u)
            return u;
          if (i.productId)
            return `product-${i.productId}`;
        }
        if ((h = r == null ? void 0 : r.items) != null && h.length) {
          const u = r.items[0];
          if (u) {
            const p = _(u.product.base);
            if (p)
              return p;
            if (u.product.base.productId)
              return `product-${u.product.base.productId}`;
          }
        }
      }, [e.objectID, i, r == null ? void 0 : r.items]), n = S(
        () => ({
          model: e.model,
          objectID: a,
          maxRecommendations: e.maxRecommendations,
          queryParameters: e.queryParameters,
          fallbackParameters: e.fallbackParameters
        }),
        [
          e.model,
          a,
          e.maxRecommendations,
          e.queryParameters,
          e.fallbackParameters
        ]
      ), c = async () => y, l = Te(), d = S(
        () => Ae(JSON.stringify(n)),
        [n]
      ), f = le(
        ne(async () => {
          const h = await l(n);
          s(h);
        }),
        [d]
      );
      ue(() => {
        f();
      }, [d]);
      const g = {
        loadPage: () => Promise.resolve([]),
        setFacets: c,
        reset: async () => await l(n),
        setSortOrder: c
      };
      return !t || t.items.length === 0 ? null : /* @__PURE__ */ A(fe.Provider, { value: g, children: /* @__PURE__ */ A(he, { result: t, children: e.children }) });
    }
  )
);
xe.displayName = "AlgoliaRecommendations";
const Ne = o.object({
  algoliaRequestOptions: o.custom().optional(),
  algoliaTypeId: o.string().default("product"),
  searchQuery: o.string().default(""),
  disjunctiveFacets: o.array(o.string()).optional(),
  facetGroupConfigs: o.custom().optional()
}), Ve = o.object({
  payload: Ne,
  children: o.custom()
}), _e = (e, r) => {
  if (!Array.isArray(e))
    return [];
  const i = [];
  return e.forEach((t) => {
    typeof t == "string" ? t.startsWith(`${r}:`) && i.push(t) : Array.isArray(t) && t.forEach((s) => {
      typeof s == "string" && s.startsWith(`${r}:`) && i.push(s);
    });
  }), i;
}, Ge = (e, r, i, t) => Object.entries(e).map(([s, a]) => {
  var c;
  let n;
  return t != null && t[s] ? n = t[s].map((l) => `${s}:${l}`) : n = _e(
    (c = r.algoliaRequestOptions) == null ? void 0 : c.facetFilters,
    s
  ), {
    name: s,
    id: s,
    type: "checkbox",
    selectedCount: n.length,
    values: Object.entries(a).map(
      ([l, d]) => i.algoliaFacetToGreaseFacetValue(s, l, d, n)
    )
  };
}), Le = (e, r) => e.filter(
  (t) => r.includes(t.id)
).sort((t, s) => {
  const a = r.indexOf(t.id), n = r.indexOf(s.id);
  return (a === -1 ? 1 / 0 : a) - (n === -1 ? 1 / 0 : n);
}), Be = (e, r, i = [], t, s) => {
  if (!e)
    return [];
  const a = Ge(
    e,
    r,
    t,
    s
  );
  return Le(a, i);
}, $ = "x", J = (e, r = $) => e.includes(r) ? e.split(r) : [], Me = (e) => {
  const r = {}, i = {};
  return e.facetIds.forEach((t) => {
    r[t] = {}, i[t] = /* @__PURE__ */ new Set();
  }), { individualFacets: r, selectedValues: i };
}, Ke = (e, r, i) => {
  e.forEach((t) => {
    J(
      t,
      r.delimiter ?? $
    ).forEach((a, n) => {
      var l;
      const c = r.facetOrder[n];
      c && a && ((l = i[c]) == null || l.add(a));
    });
  });
}, Qe = (e, r) => {
  Object.entries(e).forEach(([i, t]) => {
    t.forEach((s) => {
      var a;
      return (a = r[i]) == null ? void 0 : a.add(s);
    });
  });
}, We = (e, r, i) => {
  Object.entries(e).forEach(([t, s]) => {
    J(
      t,
      r.delimiter ?? $
    ).forEach((n, c) => {
      const l = r.facetOrder[c];
      l && n && i[l] && (i[l][n] = (i[l][n] || 0) + s);
    });
  });
}, ze = (e, r, i) => {
  const t = { ...e }, s = {};
  return i.filter(
    (n) => n.relationship === "and" && n.compositeField
  ).forEach((n) => {
    var h;
    const c = n.compositeField, l = e[c.fieldName];
    if (!l)
      return;
    const d = Ue(
      n,
      (h = r.algoliaRequestOptions) == null ? void 0 : h.facetFilters
    );
    delete t[c.fieldName];
    const { individualFacets: f, selectedValues: g } = Me(n);
    Ke(
      d.composite,
      c,
      g
    ), Qe(d.individual, g), We(
      l,
      c,
      f
    ), Object.entries(f).forEach(([u, p]) => {
      if (Object.keys(p).length > 0)
        if (!t[u])
          t[u] = p, s[u] = Array.from(g[u] || []);
        else {
          const b = s[u] || [], m = Array.from(g[u] || []);
          s[u] = [
            .../* @__PURE__ */ new Set([...b, ...m])
          ];
        }
    });
  }), {
    facets: t,
    selections: s
  };
}, Ue = (e, r) => {
  const i = {
    composite: [],
    individual: {}
  };
  if (e.facetIds.forEach((s) => {
    i.individual[s] = [];
  }), !r)
    return i;
  const t = (s) => {
    var a;
    if ((a = e.compositeField) != null && a.fieldName && s.startsWith(`${e.compositeField.fieldName}:`)) {
      const n = s.split(":")[1];
      n && i.composite.push(n);
    }
    e.facetIds.forEach((n) => {
      var c;
      if (s.startsWith(`${n}:`)) {
        const l = s.split(":")[1];
        l && ((c = i.individual[n]) == null || c.push(l));
      }
    });
  };
  return typeof r == "string" ? t(r) : Array.isArray(r) && r.forEach((s) => {
    typeof s == "string" ? t(s) : Array.isArray(s) && s.forEach((a) => {
      typeof a == "string" && t(a);
    });
  }), i;
}, He = (e, r, i, t) => {
  var l, d, f;
  if (!(r != null && r.hits))
    return y;
  const s = r.hits.map((g, h) => {
    if (T(g)) {
      const u = i.centraShopProduct(g);
      return u ? {
        type: "product",
        product: {
          ...u,
          base: {
            ...u.base,
            attributes: [
              ...u.base.attributes,
              {
                attributeKey: "algolia_query_id",
                attributeLabel: "algolia_query_id",
                value: r.queryID,
                valueLabel: r.queryID || ""
              },
              {
                attributeKey: "algolia_position",
                attributeLabel: "algolia_position",
                value: h,
                valueLabel: h.toString()
              }
            ]
          }
        }
      } : void 0;
    }
  }).filter((g) => g !== void 0);
  let a = r.facets, n;
  if (t && r.facets) {
    const g = ze(
      r.facets,
      e,
      t
    );
    a = g.facets, n = g.selections;
  }
  const c = Be(
    a,
    e,
    (f = (d = (l = r.renderingContent) == null ? void 0 : l.facetOrdering) == null ? void 0 : d.facets) == null ? void 0 : f.order,
    i,
    n
  );
  return {
    items: s,
    meta: {
      totalItems: r.nbHits ?? 0,
      itemsPerPage: r.hitsPerPage ?? 0,
      currentPage: r.page ?? 0,
      totalPages: r.nbPages ?? 0
    },
    facets: c,
    sort: []
    // Not yet supported
  };
}, Y = (e, r = []) => {
  const i = /* @__PURE__ */ new Set([e]);
  for (const t of r)
    !t.compositeField || !Array.isArray(t.facetIds) || t.facetIds.includes(e) && (i.add(t.compositeField.fieldName), t.facetIds.forEach((s) => i.add(s)));
  return Array.from(i);
}, Je = (e, r, i = []) => {
  if (!Array.isArray(e))
    return [];
  const t = Y(r, i), s = [];
  return e.forEach((a) => {
    if (typeof a == "string")
      t.some((n) => a.startsWith(`${n}:`)) && s.push(a);
    else if (Array.isArray(a)) {
      const n = a.filter(
        (c) => typeof c == "string" && t.some((l) => c.startsWith(`${l}:`))
      );
      n.length > 0 && s.push(n);
    }
  }), s;
}, Ye = (e, r, i = []) => {
  if (!Array.isArray(e))
    return [];
  const t = Y(r, i), s = [];
  return e.forEach((a) => {
    if (typeof a == "string")
      t.some((n) => a.startsWith(`${n}:`)) || s.push(a);
    else if (Array.isArray(a)) {
      const n = a.filter(
        (c) => !(typeof c == "string" && t.some((l) => c.startsWith(`${l}:`)))
      );
      n.length > 0 && s.push(n);
    }
  }), s;
}, Ze = (e) => {
  if (!e)
    return [];
  const r = [], i = (t) => {
    const s = t.indexOf(":");
    s > 0 && r.push(t.substring(0, s));
  };
  return typeof e == "string" ? i(e) : Array.isArray(e) && e.forEach((t) => {
    typeof t == "string" ? i(t) : Array.isArray(t) && t.forEach((s) => {
      typeof s == "string" && i(s);
    });
  }), [...new Set(r)];
}, Xe = async (e, r, i, t = []) => {
  var h, u, p, b;
  const s = i.disjunctiveFacets || [], a = (h = i.algoliaRequestOptions) == null ? void 0 : h.facetFilters, n = async (m) => {
    const { results: P } = await e.searchForHits({
      requests: [{ indexName: r, ...m }]
    });
    return P[0];
  };
  if (!a || Array.isArray(a) && a.length === 0) {
    const m = await n({
      ...i.algoliaRequestOptions,
      query: i.searchQuery,
      clickAnalytics: !0
      // Enable queryID for insights tracking
    });
    return s.length === 0 || s.length === 1 && s[0] === "*", m;
  }
  if (s.length === 0)
    return await n({
      ...i.algoliaRequestOptions,
      query: i.searchQuery,
      clickAnalytics: !0
      // Enable queryID for insights tracking
    });
  let c = s.filter((m) => m !== "*");
  if (s.includes("*")) {
    const { facetFilters: m, ...P } = i.algoliaRequestOptions || {}, O = await n({
      ...P,
      query: i.searchQuery,
      hitsPerPage: 0,
      page: 0,
      clickAnalytics: !0
      // Enable queryID for insights tracking
    }), w = ((b = (p = (u = O.renderingContent) == null ? void 0 : u.facetOrdering) == null ? void 0 : p.facets) == null ? void 0 : b.order) || Object.keys(O.facets || {});
    c = [
      .../* @__PURE__ */ new Set([...c, ...w])
    ];
    const re = Ze(a);
    if (c = [
      .../* @__PURE__ */ new Set([...c, ...re])
    ], t) {
      const oe = t.flatMap(
        (x) => x.compositeField ? x.facetIds : []
      );
      c = [
        .../* @__PURE__ */ new Set([...c, ...oe])
      ];
    }
  }
  const l = s.includes("*") ? c : c.filter(
    (m) => Je(a, m, t).length > 0
  ), d = [];
  d.push({
    indexName: r,
    query: i.searchQuery,
    ...i.algoliaRequestOptions,
    clickAnalytics: !0
    // Enable queryID for insights tracking
  }), l.forEach((m) => {
    d.push({
      indexName: r,
      query: i.searchQuery,
      ...i.algoliaRequestOptions,
      // Remove filters for this specific facet AND related fields to get all its values
      facetFilters: Ye(
        a,
        m,
        t
      ),
      // Only fetch facets, not hits
      hitsPerPage: 0,
      page: 0,
      // Request the specific facet
      facets: [m],
      clickAnalytics: !0
      // Enable queryID for insights tracking
    });
  });
  const { results: f } = await e.searchForHits({
    requests: d
  }), g = f[0];
  return l.length > 0 && (g.facets || (g.facets = {}), l.forEach((m, P) => {
    var w;
    const j = (w = f[P + 1].facets) == null ? void 0 : w[m];
    j && (g.facets[m] = j);
  })), g;
}, Z = () => {
  const e = R();
  return async (r) => {
    const i = await e();
    if (i)
      return await Xe(
        i.searchClient,
        i.indexName,
        r,
        r.facetGroupConfigs
      );
  };
}, F = () => {
  const e = v(), r = Z(), i = pe(), t = ye({
    zeroIndexed: !0
  }), s = S(() => (i == null ? void 0 : i()) || void 0, [i]);
  return async (a) => {
    var d;
    const n = ((d = a.algoliaRequestOptions) == null ? void 0 : d.page) ?? t, c = await r({
      ...a,
      algoliaRequestOptions: {
        ...a.algoliaRequestOptions,
        facets: ["*"],
        // Fetch all facets
        page: n,
        clickAnalytics: !0
        // Enable queryID for insights tracking
      },
      facetGroupConfigs: a.facetGroupConfigs ?? s
    });
    if (!c)
      return y;
    const l = a.algoliaTypeId;
    switch (l) {
      case "product":
        return He(
          a,
          c,
          e.mappers,
          a.facetGroupConfigs ?? s
        );
      default:
        throw new Error(`No mapper found for type id "${l}"`);
    }
  };
}, X = (e) => {
  if (e.length === 0)
    return [];
  if (e.length === 1) {
    const a = e[0];
    return a ? a.map((n) => [n]) : [];
  }
  const [r, ...i] = e;
  if (!r)
    return [];
  const t = X(i), s = [];
  for (const a of r)
    for (const n of t)
      s.push([a, ...n]);
  return s;
}, et = (e, r) => {
  const i = r.facetOrder.map(
    (a) => e[a] || []
  );
  return i.every(
    (a) => a.length > 0
  ) ? X(i).map((a) => {
    try {
      const n = r.valueFormatter(...a);
      return `${r.fieldName}:${n}`;
    } catch {
      return null;
    }
  }).filter((a) => a !== null) : [];
}, ee = (e, r) => {
  const i = [];
  return e.forEach((t) => {
    if (t.type === "group")
      if (t.relationship === "and")
        if (t.compositeField) {
          const s = {};
          t.children.forEach((n) => {
            if (n.type === "checkbox") {
              const c = n.values.filter((l) => l.selected).map((l) => r ? r(n.id, l.id) : l.id);
              c.length > 0 && (s[n.id] = c);
            }
          });
          const a = Object.keys(s).length;
          if (a > 1) {
            const n = et(
              s,
              t.compositeField
            );
            n.length > 0 && i.push(n);
          } else
            a === 1 && t.children.forEach((n) => {
              if (n.type === "checkbox") {
                const c = n.values.filter(
                  (l) => l.selected
                );
                if (c.length > 0) {
                  const l = c.map((d) => {
                    const f = r ? r(n.id, d.id) : d.id;
                    return `${n.id}:${f}`;
                  });
                  i.push(l);
                }
              }
            });
        } else
          t.children.forEach((s) => {
            if (s.type === "checkbox") {
              const a = s.values.filter(
                (n) => n.selected
              );
              if (a.length > 0) {
                const n = a.map((c) => {
                  const l = r ? r(s.id, c.id) : c.id;
                  return `${s.id}:${l}`;
                });
                i.push(n);
              }
            }
          });
      else {
        const s = [];
        t.children.forEach((a) => {
          a.type === "checkbox" && a.values.filter(
            (c) => c.selected
          ).forEach((c) => {
            const l = r ? r(a.id, c.id) : c.id;
            s.push(`${a.id}:${l}`);
          });
        }), s.length > 0 && i.push(s);
      }
    else if (t.type === "checkbox") {
      const s = t.values.filter((a) => a.selected);
      if (s.length > 0) {
        const a = s.map((n) => {
          const c = r ? r(t.id, n.id) : n.id;
          return `${t.id}:${c}`;
        });
        i.push(a);
      }
    }
  }), i;
}, tt = (e) => {
  const r = F(), i = v();
  return async (t, s) => {
    var c;
    const a = {
      ...e,
      algoliaRequestOptions: {
        ...e.algoliaRequestOptions,
        facetFilters: [
          ...((c = e.algoliaRequestOptions) == null ? void 0 : c.facetFilters) || [],
          ...ee(
            (s == null ? void 0 : s.facets) || [],
            i.mappers.resolveFacetValueForFilter
          )
        ],
        page: t - 1
        // Algolia starts counting pages from 0
      }
    };
    return (await r(a)).items;
  };
}, rt = (e) => {
  const r = F(), i = v();
  return async (t) => {
    var a;
    const s = {
      ...e,
      algoliaRequestOptions: {
        ...e.algoliaRequestOptions,
        facetFilters: [
          ...((a = e.algoliaRequestOptions) == null ? void 0 : a.facetFilters) || [],
          ...ee(
            t,
            i.mappers.resolveFacetValueForFilter
          )
        ],
        offset: 0
        // Always reset pagination when changing facets
      }
    };
    return await r(s);
  };
}, It = K(
  "AlgoliaSearchResultsProvider",
  Q(Ve, (e) => {
    const r = F(), i = tt(e.payload), t = rt(e.payload), s = S(
      () => ({
        payload: e.payload,
        algoliaTypeId: e.payload.algoliaTypeId
      }),
      [e.payload]
    ), a = S(
      () => ({
        fetchSearchResult: async () => await r(e.payload),
        loadPage: i,
        setFacets: t,
        setSortOrder: async () => Promise.resolve(y)
      }),
      [r, e.payload, i, t]
    );
    return /* @__PURE__ */ A(de, { children: e.payload.algoliaTypeId === "product" && /* @__PURE__ */ A(
      be,
      {
        queryParams: s,
        searchMethods: a,
        children: e.children
      }
    ) });
  })
);
class ot {
  constructor(r, i) {
    this.algoliaSearch = r, this.algoliaConfig = i, this.search = async (t) => {
      const s = {
        productSuggestions: []
      };
      try {
        const a = await this.algoliaSearch({
          algoliaTypeId: "product",
          searchQuery: t.searchQuery,
          algoliaRequestOptions: {
            hitsPerPage: t.limit,
            clickAnalytics: !0
            // Enable queryID for insights tracking
          }
        });
        return a ? {
          productSuggestions: this.mapProducts(
            a.hits
          )
        } : s;
      } catch (a) {
        return console.error("Error in algolia auto-complete search:", a), s;
      }
    };
  }
  mapProducts(r = []) {
    return r.filter(T).map(this.algoliaConfig.mappers.centraShopProduct).filter((i) => i !== void 0);
  }
}
const Dt = (e) => {
  const r = Z(), i = v();
  return /* @__PURE__ */ A(
    Pe,
    {
      autoCompleteClient: new ot(r, i),
      children: e.children
    }
  );
}, it = (e) => {
  var r;
  return /* @__PURE__ */ A(z.Provider, { value: e.algoliaConfig, children: /* @__PURE__ */ ge(W.Provider, { value: e.algoliaClientDataGetter, children: [
    ((r = e.algoliaConfig.insights) == null ? void 0 : r.userToken) && /* @__PURE__ */ A(ve, {}),
    e.children
  ] }) });
};
it.displayName = "AlgoliaProvider";
const Et = (e) => {
  const r = F();
  return async () => await r(e);
};
function Ft(e, r, i) {
  try {
    const t = Object.values(e.items);
    if (t.length === 1) {
      const a = t[0];
      if (!a)
        throw Error(
          `Product "${e.product}" has no items, cannot create product`
        );
      return {
        base: G(e, i),
        dataModel: "simple",
        isBundle: e.bundleInfo !== void 0,
        siblingProducts: [],
        itemId: a.item,
        ...te(
          e,
          a,
          r
        )
      };
    }
    return {
      dataModel: "with_variants",
      base: G(e, i),
      siblingProducts: [],
      variants: t.map(
        (a) => ut(
          e,
          a,
          r,
          i
        )
      )
    };
  } catch (t) {
    console.error(`Error while converting product "${e.product}"`, t);
    return;
  }
}
function G(e, r) {
  return {
    productId: e.product,
    productKey: e.product,
    slug: e.uri,
    discontinued: !1,
    content: st(
      e,
      r
    ),
    attributes: mt(e),
    categories: nt(e)
  };
}
function st(e, r) {
  return {
    name: e.name,
    description: e.description,
    shortDescription: e.excerpt,
    media: at(
      e,
      r
    ),
    badges: []
  };
}
function at(e, r) {
  const i = e.media;
  return i.length ? i.map((s) => {
    var n;
    const a = (n = s.sources[r.productImageKey]) == null ? void 0 : n.url;
    if (a)
      return {
        type: "image",
        src: a,
        alt: e.name
      };
  }).filter((s) => i !== void 0) : (console.error(`Product "${e.product}" has no media"`), []);
}
function nt(e) {
  return Object.values(e.categories).map((i) => ({
    categoryId: i.category.toString(),
    // categoryKey: category.category needed?
    name: i.name,
    slug: i.uri
  }));
}
function ct(e, r) {
  const i = e.stockByMarket[r];
  return i === void 0 ? (console.warn("Stock not found for market", r), 0) : typeof i == "string" && i === "infinite" ? 999999 : i ?? 0;
}
function lt(e, r) {
  var s;
  const i = e[r.market];
  if (!i)
    throw Error(
      `AlgoliaShopProduct is missing market data for ${r.market}`
    );
  const t = (s = i == null ? void 0 : i.pricesByPricelist) == null ? void 0 : s[r.pricelist];
  if (!t)
    throw Error(
      `AlgoliaShopProduct is missing pricelist data for ${r.pricelist}`
    );
  return {
    price: {
      formatted: t.price,
      number: t.priceAsNumber
    },
    priceWithoutDiscount: {
      formatted: t.priceBeforeDiscount,
      number: t.priceBeforeDiscountAsNumber
    },
    // TODO: lowest prices implementation below
    previouslyDiscountedPrices: []
    // previouslyDiscountedPrices: {
    //   date: string;
    //   price: string;
    //   priceNumber: number;
    //   priceWithoutDiscount: string;
    //   priceWithoutDiscountNumber: number;
    // }[];
    // TODO: discount info below
    // discountInfo?: {
    //   percent: number;
    // } | undefined;
  };
}
function te(e, r, i) {
  const t = ct(r, i.market), s = t > 0, a = lt(e.markets, i);
  return {
    sku: r.sku,
    inventory: {
      quantity: t,
      inStock: s,
      warehouseId: "1"
    },
    additionalInventory: [],
    priceInfo: a
  };
}
function ut(e, r, i, t) {
  return {
    dimensions: dt(r, t),
    label: r.name,
    mainProductId: e.product,
    mainProductKey: e.product,
    variantId: r.item,
    variantKey: r.item,
    ...te(
      e,
      r,
      i
    )
  };
}
const dt = (e, r) => {
  const i = r.itemIdDimensionParser;
  if (!i)
    return [L(e)];
  const t = e.name.split(i.delimiter);
  return t.length === 1 ? [L(e)] : t.map(
    (s, a) => gt(s, i.dimensionInfo[a])
  );
}, E = {
  key: "size",
  label: "Item_Dimension_Size"
}, L = (e) => ({
  value: e.name,
  valueLabel: e.name,
  dimensionKey: E.key,
  dimensionLabel: E.label
}), gt = (e, r) => ({
  value: e,
  valueLabel: e,
  dimensionKey: (r == null ? void 0 : r.key) ?? E.key,
  dimensionLabel: (r == null ? void 0 : r.label) ?? E.label
});
function mt(e) {
  const r = Object.keys(e).filter(
    (t) => !qe.shape.hasOwnProperty(t)
  ).reduce((t, s) => [
    ...t,
    {
      attributeKey: s,
      attributeLabel: s,
      value: e[s],
      valueLabel: `${e[s]}`
      // Centra doesn't support value labels for attributes , so we cant have in algolia either
    }
  ], []).filter((t) => t.value !== void 0), i = `product-${e.product}`;
  return [
    ...r,
    {
      attributeKey: D,
      attributeLabel: D,
      value: i,
      valueLabel: i
    }
  ];
}
const Ot = (e, r, i, t) => ({
  id: r,
  name: r,
  selected: t.includes(`${e}:${r}`),
  disabled: !1,
  count: i
});
export {
  D as ALGOLIA_OBJECT_ID_ATTRIBUTE_KEY,
  ot as AlgoliaAutoCompleteClient,
  Dt as AlgoliaAutoCompleteProvider,
  ve as AlgoliaNotifications,
  it as AlgoliaProvider,
  xe as AlgoliaRecommendations,
  It as AlgoliaSearchResultsProvider,
  $ as DEFAULT_DELIMITER,
  te as algoliaCentraShopApiItemToGreasePurchaseInfo,
  qe as algoliaCentraShopApiProductSchema,
  Ft as algoliaCentraShopApiProductToGreaseProduct,
  G as algoliaCentraShopApiProductToGreaseProductBase,
  st as algoliaCentraShopApiProductToGreaseProductContent,
  at as algoliaCentraShopApiProductToGreaseProductMediaImages,
  ut as algoliaCentraShopApiProductToGreaseProductVariant,
  H as algoliaCentraShopProductTypeSchema,
  W as algoliaClientDataContext,
  z as algoliaConfigContext,
  Be as algoliaFacetsToGreaseFacets,
  $e as algoliaRecommendationQuerySchema,
  Ne as algoliaSearchPayloadSchema,
  Ve as algoliaSearchProviderSchema,
  He as algoliaSearchResponseToGreaseSearchResult,
  We as decomposeCompositeData,
  ze as decomposeCompositeFacets,
  Ot as defaultAlgoliaFacetToGreaseFacetValue,
  Ct as emptyArraySchema,
  X as generateFacetGroupCombinations,
  et as generateFacetGroupFilters,
  _ as getAlgoliaObjectId,
  mt as getExtraAttributesForProduct,
  nt as getProductCategories,
  lt as getProductPrice,
  ct as getStockByMarket,
  dt as getVariantDimensions,
  Me as initializeIndividualFacets,
  T as isAlgoliaCentraShopApiProduct,
  J as parseCompositeValue,
  Xe as performDisjunctiveSearch,
  Ke as processCompositeSelections,
  Qe as processIndividualSelections,
  ee as searchResultFacetsToAlgoliaFacetFilters,
  Fe as shopProductBundleInfoSchema,
  De as shopProductBundleProductSchema,
  U as shopProductBundleQuantitySchema,
  Ee as shopProductBundleSchema,
  ke as shopProductCategorySchema,
  Oe as shopProductItemSchema,
  we as shopProductLowestPriceSchema,
  Ce as shopProductMarketPricelistSchema,
  Ie as shopProductMarketSchema,
  je as shopProductSchema,
  q as shopProductStockAmountSchema,
  v as useAlgoliaConfig,
  Te as useAlgoliaFetchRecommendations,
  F as useAlgoliaFetchSearchResult,
  tt as useAlgoliaLoadPage,
  Et as useAlgoliaReset,
  Z as useAlgoliaSearch,
  R as useAlgoliaSearchClientDataGetter,
  Se as useAlgoliaSendInsights,
  rt as useAlgoliaSetFacets
};
//# sourceMappingURL=lib.es.js.map
